export const PATHS = {
  byLocationName: ({ units, locationQuery }) =>
    `https://api.openweathermap.org/data/2.5/forecast/daily?q=${locationQuery}&cnt=5&appid=91b1dc1ee1d16d9ec4300559a27c844a&units=${units}`,
  byZipCode: ({ units, locationQuery }) =>
    `https://api.openweathermap.org/data/2.5/forecast/daily?zip=${locationQuery}&cnt=5&appid=91b1dc1ee1d16d9ec4300559a27c844a&units=${units}`,
};

export default PATHS;